module.exports = __webpack_public_path__ + "static/images/components/LoadingScreen/images/spinner.RU.efe16efc.png";


//////////////////
// WEBPACK FOOTER
// ./components/LoadingScreen/images/spinner.RU.png
// module id = 2606
// module chunks = 11